import React from "react";
import { MessageCircle } from "lucide-react";
import { useContent } from "../lib/content";
import { buildWhatsAppLink } from "../lib/api";

export default function WhatsAppFab() {
  const { settings } = useContent();
  if (!settings.whatsapp_number) return null;
  return (
    <a
      href={buildWhatsAppLink(settings.whatsapp_number, "سلام، درباره محصولات تحسین سوال داشتم.")}
      target="_blank"
      rel="noreferrer"
      aria-label="سفارش از طریق واتساپ"
      className="fixed bottom-6 left-6 z-40 w-14 h-14 rounded-full bg-[#25D366] hover:bg-[#128C7E] text-white flex items-center justify-center shadow-lg shadow-green-900/20 animate-float"
      data-testid="whatsapp-fab"
    >
      <MessageCircle className="w-6 h-6" />
    </a>
  );
}
